<template>
<router-link to="/" class="brand-link">
    <img src="@/assets/img/logo.png" alt="PUBLISHER" class="brand-image">
    <span class="text-primary brand-text font-weight">PUBLISHER</span>
    
    <template v-if="installation == 'DEV'">
    <sup class="bg-danger rounded" style="padding:1px 5px 2px; margin-left:5px;"><small>DEV {{ version }}</small></sup>
    </template>
    <template v-else-if="installation == 'PREVIEW'">
    <sup class="bg-warning rounded" style="padding:1px 5px 2px; margin-left:5px;"><small>BETA {{ version }}</small></sup>
    </template>
    <template v-else>
    <sup style="margin-left: 5px;"><small>{{ version }}</small></sup>
    </template>
    
</router-link>
</template>
<script setup>
import version from '@/version';

const installation = import.meta.env.VITE_APP_INSTALLATION;
</script>